import React from 'react';
import { ConfigurationTemplate } from '../template/configurationTemplate';

export const ConfigurationPage = ({ history }) => (
  <ConfigurationTemplate goBack={() => history.goBack()} />
);
